import React, { useContext, useEffect, useState } from "react";
import UserIcon from "@heroicons/react/24/outline/UserIcon";
import { Bars3Icon, UserCircleIcon } from "@heroicons/react/24/outline";
import AuthContext from "../../context/auth/AuthContext";
import { isEmpty } from "../../helpers/validator";

function Navbar({ onNavbarToggle }) {
  const [name, setName] = useState("");

  const { user } = useContext(AuthContext);

  useEffect(() => {
    let fullname = [user?.firstName, user?.lastName].join(" ");

    if (isEmpty(fullname)) {
      fullname = "User";
    }
    setName(fullname);
  }, [user]);

  const handleMenuToggle = () => {
    onNavbarToggle();
  };

  return (
    <div className="flex items-center justify-between p-4 shadow-lg h-20 z-10 w-full bg-white">
      <Bars3Icon
        className="lg:hidden w-6 h-6 cursor-pointer"
        onClick={handleMenuToggle}
      />

      <div></div>

      <div className="flex gap-2 items-center mr-4">
        <div className="w-10 h-10 p-2 rounded-full">
          <UserCircleIcon className="text-gray-800 w-full h-full" />
        </div>
        <div>{name}</div>
      </div>
    </div>
  );
}

export default Navbar;
